<template>
  <div class="store-item">
    <div class="store-item__header">
      <router-link class="store-item__title" :to="visitLink">
        {{ `${store.store_name} - ${ maskableTime(store.uploaded_at)}` }}
      </router-link>
      <DownloadButton :downloading="imageDownloading" @click="downloadStoreImages" />
    </div>
    <div class="store-item__imagesets">
      <ImagesetGroup v-for="(imageset,index) in imagesWithRemains"
                     :key="imageset.id + index"
                     :imageset="imageset"
                     :store="store"
                     :max-image-count-per-row="maxImageCountPerRow"
                     :image-box-width="imageBoxWidth" />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import breadcrumbs from '@/router/breadcrumbs';
import ImagesetGroup from './ImagesetGroup';
import ImageDownloadMixin from './ImageDownloadMixin';

export default {
  name: 'ImageNavigatorStoreItem',
  components: {
    ImagesetGroup
  },
  mixins: [ImageDownloadMixin],
  props: {
    store: {
      type: Object,
      required: true
    },
    maxImageCountPerRow: {
      type: Number,
      default: 8
    },
    imageBoxWidth: {
      type: Number,
      default: 250
    },
    wrapperWidth: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      storeDownloading: false
    };
  },
  computed: {
    imagesWithRemains() {
      const imagesWithRemains = [];
      const wrapperPaddingGap = 24;
      const imagesetBoxPaddingGap = 22;
      const minImagesetWidth = this.imageBoxWidth + imagesetBoxPaddingGap + 95;
      const additionalImageWith = this.imageBoxWidth + 10;
      const rowSpace = (this.wrapperWidth - wrapperPaddingGap);
      const imagesetBorderGap = 2;

      let rowSpaceLeft = rowSpace;

      this.store.image_sets.forEach((imageset) => {
        if (imageset.images.length === 1) {
          if ((rowSpaceLeft - minImagesetWidth) < 0) {
            rowSpaceLeft = rowSpace;
          }

          rowSpaceLeft -= minImagesetWidth;
          imagesWithRemains.push({
            ...imageset, remain: false, gonnaRemain: false
          });
        } else {
          imagesWithRemains.push({
            ...imageset, remain: false, gonnaRemain: false, images: []
          });

          imageset.images.forEach((image, index) => {
            const isLastImage = imageset.images.length === (index + 1);
            const neededImageSpace = index === 0 ? additionalImageWith + imagesetBorderGap + 10 : additionalImageWith + imagesetBorderGap;

            if (rowSpaceLeft - neededImageSpace > 0) {
              rowSpaceLeft -= neededImageSpace;

              imagesWithRemains[imagesWithRemains.length - 1].images.push(image);
            } else {
              const spaceGonnaTake = isLastImage ? minImagesetWidth : neededImageSpace;

              rowSpaceLeft = rowSpace;
              rowSpaceLeft -= spaceGonnaTake;
              if (imagesWithRemains[imagesWithRemains.length - 1].images.length > 0) {
                imagesWithRemains[imagesWithRemains.length - 1].gonnaRemain = true;
                imagesWithRemains.push({
                  ...imageset, remain: true, gonnaRemain: false, images: [image]
                });
              } else {
                imagesWithRemains[imagesWithRemains.length - 1].images.push(image);
              }
            }
          });
        }
      });

      return imagesWithRemains;
    },
    visitLink() {
      return {
        name: breadcrumbs.visitsDetail,
        params: {
          visitId: this.store.id
        }
      };
    }
  },
  methods: {
    downloadStoreImages() {
      const images = [];

      this.store.image_sets.forEach((imageset) => {
        const mappedImages = imageset.images.map(i => ({ ...i, activity_category_name: imageset.activity_category_name, image_set_type_name: imageset.image_set_type_name }));
        images.push(...mappedImages);
      });

      this.downloadImages(images, `${moment(this.store.uploaded_at).format(!this.maskTimeData ? 'YYYYMMDD_HHmm' : 'YYYYMMDD')}_${this.store.store_name}`, this.imageNamePrefix);
    },
    imageNamePrefix(image) {
      return `${image.activity_category_name}_${image.image_set_type_name}_${image.position}_${image.id}`;
    }
  }
};
</script>

<style lang="scss" scoped>
    .store-item {
      margin-bottom: 15px;
      background: #fff;

      &__header {
        display: flex;
        justify-content: space-between;
        padding: 13px 10px;
        background: #fff;
        border-bottom: 2px solid #f1f1f1;
      }

      &__title {
        margin-bottom: 1px;
        font-size: 14px;
        font-weight: bold;
        color: $darkSkyBlue;
      }

      &__imagesets {
        display: flex;
        flex-wrap: wrap;
      }
    }
</style>
